import AuditLogsDetailsModal from "./AuditLogsDetailsModal";

export default AuditLogsDetailsModal;